import { FC } from "react";
import { Dialog, Flex, Text } from "@chakra-ui/react";

import SuccessPayedIcon from "@assets/files/images/icons/successPayedIcon.svg?react";
import { CloseButton } from "@shared/components";

const CasePaymentSuccessModal: FC = () => {
  return (
    <>
      <Dialog.Header pt={5}>
        <Flex justify="center">
          <SuccessPayedIcon />
        </Flex>
        <Dialog.CloseTrigger asChild>
          <CloseButton />
        </Dialog.CloseTrigger>
      </Dialog.Header>
      <Dialog.Body p={5}>
        <Text textStyle="subtitle" textAlign="center">
          Payment completed
        </Text>
        <Text color="brand.grey" mt={3} textAlign="center">
          <strong>Please be informed:</strong> your case is in progress. You&apos;ll be emailed the full report with
          answers reviewed by an expert in 72h.
        </Text>
      </Dialog.Body>
    </>
  );
};

export default CasePaymentSuccessModal;
